import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.css';
import { BreadcrumbSchema } from './StructuredData';

const Breadcrumbs = ({ customItems = null, className = "" }) => {
  const location = useLocation();
  const pathname = location.pathname;
  
  const generateBreadcrumbs = () => {
    if (customItems) return customItems;
    
    const pathParts = pathname.split('/').filter(part => part !== '');
    const breadcrumbs = [{ name: 'Home', path: '/' }];
    
    let currentPath = '';
    pathParts.forEach((part, index) => {
      currentPath += `/${part}`;
      
      let name = decodeURIComponent(part).replace(/-/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase()).replace(/\bp11d\b/gi, 'P11D');
      
      // Skip parent pages that don't exist
      if (part === 'services' || part === 'success-stories') {
        // Don't add to breadcrumbs, but continue building path
        return;
      }
      
      // Custom naming for specific routes
      if (part === 'sme') name = 'SME Services';
      if (part === 'large-enterprise') name = 'Large Enterprise';
      if (part === 'consultancy') name = 'Consultancy';
      if (part === 'about') name = 'About Us';
      if (part === 'contact') name = 'Contact Us';
      if (part === 'blog') name = 'Blog';
      if (part === 'quote') name = 'Get Quote';
      if (part === 'faq') name = 'FAQ';
      
      breadcrumbs.push({
        name,
        path: currentPath
      });
    });
    
    return breadcrumbs;
  };
  
  const breadcrumbs = generateBreadcrumbs();
  
  if (breadcrumbs.length <= 1) return null;
  
  return (
    <>
      <BreadcrumbSchema items={breadcrumbs} />
      <nav className={`gpm-breadcrumb ${className}`} aria-label="Breadcrumb" data-page={pathname}>
        <ol className="gpm-breadcrumb-list">
          {breadcrumbs.map((crumb, index) => (
            <li key={crumb.path}>
              {index > 0 && <span className="gpm-breadcrumb-separator" aria-hidden="true">/</span>}
              {index === breadcrumbs.length - 1 ? (
                <span className="gpm-breadcrumb-current" aria-current="page" title={crumb.name}>{crumb.name}</span>
              ) : (
                <Link to={crumb.path}>{crumb.name}</Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;